import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { FlexRowCenter, FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { SvgIcon, IconType } from '../General/SvgIcon';
import Select from 'react-select';
import { CSSProperties } from 'react';

interface Props {
  id?: string;
  name?: string;
  label?: string;
  maxWidth?: number;
  marginBottom?: number;
  options: Array<{
    name: string;
    value: string;
    image?: string;
  }>;
  autoComplete?: string;
  defaultValue?: {
    name: string;
    value: string | undefined | number;
  };
  onChange: (e: any) => void;
  onBlur?: () => void;
  placeholder?: string;
  mobileMarginBottom?: number;
  marginRight?: number;
  mobileMarginRight?: number;
  required?: boolean;
  disabled?: boolean;
}

export function ProductDetailSelect({
  options,
  onChange,
  maxWidth = 280,
  marginBottom = 0,
  marginRight = 32,
  mobileMarginBottom = 32,
  mobileMarginRight = 0,
  label,
}: Props) {
  const imageStyle: CSSProperties = {
    height: `32px`,
    width: `32px`,
  };

  const indicatorSeparatorStyles = (base, state) => {
    const changes = {
      display: 'none',
    };
    return Object.assign(base, changes);
  };

  const dropdownIndicatorStyles = (base, state) => {
    const changes = {
      padding: `${rem(16)}`,
      color: '#07151C',
    };
    return Object.assign(base, changes);
  };

  const selectStyles = {
    indicatorSeparator: indicatorSeparatorStyles,
    dropdownIndicator: dropdownIndicatorStyles,
    control: (styles, { isDisabled }) => ({
      ...styles,
      backgroundColor: 'white',
      height: `${rem(56)}`,
      boxShadow: 'none',
      borderRadius: `${rem(4)}`,
      borderColor: '#EEEEEE',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      '&:hover': {
        borderColor: '#EEEEEE',
      },
    }),
    option: (styles, { isDisabled }) => {
      return {
        ...styles,
        color: '#07151C',
        backgroundColor: 'white',
        borderColor: '#EEEEEE',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        ':active': {
          ...styles[':active'],
          backgroundColor: 'white',
        },
      };
    },
    input: styles => ({ ...styles }),
    placeholder: styles => ({ ...styles }),
    singleValue: (styles, { data }) => ({
      ...styles,
    }),
  };

  const mappedOptions = Array();
  options.forEach(o => {
    mappedOptions.push({
      value: o.value,
      label: (
        <div>
          <img style={imageStyle} src={o.image} /> {o.name}{' '}
        </div>
      ),
    });
  });

  return (
    <Wrapper
      mobileMarginBottom={mobileMarginBottom}
      marginBottom={marginBottom}
      maxWidth={maxWidth}
      marginRight={marginRight}
      mobileMarginRight={mobileMarginRight}
    >
      <Select
        defaultValue={mappedOptions[0]}
        options={mappedOptions}
        styles={selectStyles}
        onChange={onChange}
        isSearchable={false}
      />
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)<{
  marginRight: number;
  maxWidth: number;
  marginBottom: number;
  mobileMarginBottom: number;
  mobileMarginRight: number;
}>`
  width: 100%;
  color: #aaaaaa;
  position: relative;
  margin-right: ${({ marginRight }) => rem(marginRight)};
  margin-bottom: ${({ marginBottom }) => rem(marginBottom)};
  font-size: ${rem(14)};
  font-family: ${({ theme }) => theme.font.primary};

  &:focus-within {
    color: ${props => props.theme.colors.btnPrimary};
  }

  ${({ theme }) => theme.mediab.l925`
    margin: 0;
    margin-right: ${({ mobileMarginRight }) => rem(mobileMarginRight)};
    margin-bottom:  ${({ mobileMarginBottom }) => rem(mobileMarginBottom)};
  `}
`;

export { Select };
